export default __webpack_public_path__ + "static/og-default-3e30aa5d630ae6c711b8b08b6acd1c52.png";